import { variantColors } from './variant-colors/variant-colors';

export const fns = {
  variantColors,
};
